
<script lang="ts">
import { defineComponent } from '@vue/composition-api';

interface IProps {
    isOpen: boolean;
}

export default defineComponent<IProps>({
    name: 'AppSlidePanel',
    props: {
        isOpen: Boolean,
    },
});
</script>


<template functional>
  <portal v-if="props.isOpen" to="slidePanel">
    <slot />
  </portal>
</template>
